export const DefaultIsRegisteredQueryOptions = {
    searchParentContainers: true
}